import { useMemo } from "react";
import { useT } from "./use-pages-i18n";
export const usePages = () => {
    const { t } = useT();
    return useMemo(() => [
        {
            key: "invoice",
            name: t.invoice,
            icon: "Money",
            pages: [
                {
                    key: "invoice:dynamicInvoiceList",
                    name: t.dynamicInvoiceList,
                    url: "dynamic-invoice"
                }
            ]
        }
    ], [t]);
};
